module.exports = __webpack_public_path__ + "img/consGamb.a69633a4.jpg";